import React, { useEffect, useState } from "react";
import { useLocation, useHistory, useParams } from "react-router-dom";
import "./themeRegionDiv.css";
import { MdNightlight, MdSunny } from "react-icons/md";
import { SlGlobe } from "react-icons/sl";
import { getLighterHexColor } from "../../utils/cssUtils.js";
import Flag from "react-world-flags";
import { getFlagCountryCode } from "../../locales/commonDictionary.js";

const ThemeRegionDiv = (props) => {
  const [isSticky, setIsSticky] = useState(props.isSticky || false);
  const [regionIconClass, setRegionIconClass] = useState("region-text");

  // Localized text variables
  const localizedText = {
    changeTheme: props.localizedText?.["change-theme"] || "Change Theme",
    language: props.localizedText?.["language"] || "Language",
  };

  // Optional: mimic `withRouter`
  const location = useLocation();
  const history = useHistory();
  const params = useParams();

  useEffect(() => {
    setIsSticky(props.isSticky);
  }, []);

  useEffect(() => {
    if (props.isSticky !== isSticky) {
      setRegionIconClass(props.isSticky ? "region-text sticky" : "region-text");
      setIsSticky(props.isSticky);
    }
  }, [props]);

  const toggleTheme = (theme) => {
    props.changeTheme(theme);
  };

  return (
    <div
      className={
        "theme-region-div " + (props.userVerified ? "" : "user-not-verified")
      }
    >
      {process.env.REACT_APP_THEMES === "2" ? (
        <>
          {props.theme === "dark" ? (
            <div
              className="theme-region-button"
              onClick={() => toggleTheme("light")}
            >
              <MdNightlight className="theme-toggle-icon" />
              {localizedText.changeTheme}
            </div>
          ) : (
            <div
              className="theme-region-button"
              onClick={() => toggleTheme("dark")}
            >
              <MdSunny className="theme-toggle-icon" />
              {localizedText.changeTheme}
            </div>
          )}
        </>
      ) : null}

      <div
        className="theme-region-button right-button"
        onClick={props.handleModalOpen}
      >
        <Flag
          className="flag-icon theme-toggle-icon"
          code={getFlagCountryCode(
            props.region.toUpperCase(),
            props.config.domicile,
          )}
        />
        {localizedText.language}
        <div className="current-region">{"(" + props.region + ")"}</div>
      </div>
    </div>
  );
};

export default ThemeRegionDiv;
